export enum SupplierDocumentKind {
  DeliveryNote = 0,
  Invoice = 1
}